import React from 'react'
import JiaMengHeader from '@components/JiaMeng/Header/Customer'
import NewCustomer from '@components/JiaMeng/NewCustomer/list'
import NewCustomerDetail from '@components/JiaMeng/NewCustomer/detail'

export default {
  path: 'newCustomer',
  component: props => <JiaMengHeader key="newCustomer" {...props} />,
  indexRoute: {
    component: NewCustomer
  },
  stat: '加盟店客资/首页',
  childRoutes: [
    {
      path: 'detail/:id',
      component: NewCustomerDetail,
      stat: '加盟店客资/客资详情'
    }
  ]
}
